var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex",attrs:{"id":"admin"}},[_c('MainNavBar'),_c('main',{staticClass:"flex flex-col w-full px-5 md:px-10 pt-10 pb-20 bg-gray-100 scroller-width"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }